import {
  Component, Input, Output, EventEmitter,
} from '@angular/core';
import * as _ from 'lodash';


@Component({
  moduleId: module.id,
  selector: 'app-tabs',
  templateUrl: 'tabs.component.html',
  styleUrls: ['tabs.component.scss'],
})
export class TabsComponent {
  @Input() isClickableWhenActive: boolean = false;

  @Input() leftTitle: string;
  @Input() leftActive: boolean;
  @Input() leftAllowClick: boolean = true; // enable/disable clicking

  @Input() rightTitle: string;
  @Input() rightActive: boolean;
  @Input() rightAllowClick: boolean = true; // enable/disable clicking

  @Input() ghostValue: string = 'app-tabs';

  @Output() leftTabClick: EventEmitter<any> = new EventEmitter();
  @Output() rightTabClick: EventEmitter<any> = new EventEmitter();

  /*******************************************
   * COMPONENT EVENT HANDLERS
   *******************************************/

  onLeftTabClick() {
    if (this.leftAllowClick && (this.isClickableWhenActive || !this.leftActive)) {
      this.leftTabClick.emit();
    }
  }

  onRightTabClick() {
    if (this.rightAllowClick && (this.isClickableWhenActive || !this.rightActive)) {
      this.rightTabClick.emit();
    }
  }
}
